import React from 'react';

const JSON_vs_XML = () => {
  return (
    <div >
      <h1>JSON_vs_XML</h1>
      <p>Placeholder component for: "JSON vs XML"</p>
    </div>
  );
};

export default JSON_vs_XML;
